import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { getDateText, getTime } from "../../../utils/date";
import SauvegardeManager from "../../SauvegardeManager";

export default class Smartphone extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        // Gestion de la progression
        this.sauvegardeManager = new SauvegardeManager()
        this.progression = this.sauvegardeManager.getChapitreProgression("Chapitre3_1")["smartphone"];
        this.config = this.scene.cache.json.get('config')['Chapitre3_1']['smartphone']

        // Ajout fond ordi
        this.background = this.scene.add.image(0, 0, 'smartphone_background').setOrigin(0.5, 0);
        this.background.setInteractive();
        this.add(this.background);

        // Ajout liens externes (google, wikipedia, etc)
        this.icons = []
        this.addIcons()

        this.setSize(this.background.width, this.background.height);

        // Ajout de l'heure
        this.heureText_0 = this.scene.add.text(-this.background.width/2 + 50, 116, getTime(), {
            fontSize: '140px',
            fontFamily: FONTS.Inter28Light,
            color: Colors.Text.White,
            shadow: {
                offsetX: 0,
                offsetY: 3,
                color: '#00000016',
                blur: 6,
            },
        }).setOrigin(0);
        this.add(this.heureText_0);

        this.heureText_1 = this.scene.add.text(-this.background.width/2 + 75, 50, getTime(), {
            fontSize: '18px',
            fontFamily: FONTS.Inter28SemiBold,
            color: Colors.Text.Black
        }).setOrigin(0);
        this.add(this.heureText_1);

        // Ajout de la date
        this.dateText_0 = this.scene.add.text(-this.background.width/2 +60, 272, getDateText(), {
            fontSize: '40px',
            fontFamily: FONTS.Inter28Light,
            color: Colors.Text.White,
            shadow: {
                offsetX: 0,
                offsetY: 3,
                color: '#00000016',
                blur: 6,
            },
        }).setOrigin(0);
        this.add(this.dateText_0);

        setTimeout( () => {
            this.updateTime();
        }, 5000);

    }

    updateTime(){
        if(!this)
            return;

        this.heureText_0.text = getTime();
        this.dateText_0.text = getDateText();
    }

    animIn(endFunc){
        this.y+= 200
        this.soundManager.playOnce('Smartphone')
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: (this.y - 200),
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    animOut(endFunc){
        this.soundManager.playOnce('Smartphone')
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: this.y + 200,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    // Block
    lockButtons(){
        this.icons.forEach( button => {
            button.disableInteractive();
        })
    }

    unlockButtons(){
        this.icons.forEach( button => {
            button.setInteractive({useHandCursor: true});
        })
    }

    // Ajout liens externes sur le bureau de l'ordi
    addIcons(){
        let positions = [
            {x: 0, y: 668},
            {x: 140, y: 802},
            {x: -140, y: 920},
            {x: 0, y: 920},
            {x: 140, y: 920},
        ]

        Object.keys(this.config.liens).forEach( (icon, index) => {
            let iconElmt = this.scene.add.image(positions[index].x, positions[index].y, icon).setOrigin(0.5);
            this.add(iconElmt)
            this.icons.push(iconElmt);

            iconElmt.setInteractive({useHandCursor: true})
            iconElmt.on('pointerup', () => {
                this.scene.tweens.add({
                    targets: iconElmt,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        window.open(this.config.liens[icon], '_blank');
                    }
                })
            })
        })
    }
}